import Vue from 'vue';
import Router from 'vue-router';
import HomePage from './views/Home.vue';
import RsvpPage from './views/Rsvp.vue';
import AboutUsPage from './views/AboutUs.vue';
import LodgingPage from './views/Lodging.vue';
import ThingsToDoPage from './views/ThingsToDo.vue';
import RegistryPage from './views/Registry.vue';
import PhotosPage from './views/Photos.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'home',
      component: HomePage
    },
    {
      path: '/rsvp',
      name: 'rsvp',
      component: RsvpPage
    },
    {
      path: '/about-us',
      name: 'about-us',
      component: AboutUsPage
    },
    {
      path: '/lodging',
      name: 'lodging',
      component: LodgingPage
    },
    {
      path: '/things-to-do',
      name: 'things-to-do',
      component: ThingsToDoPage
    },
    {
      path: '/registry',
      name: 'registry',
      component: RegistryPage
    },
    {
      path: '/photo-gallery',
      name: 'photo-gallery',
      component: PhotosPage
    }
  ]
});
